import React from 'react';
import { translate } from 'react-i18next';

/**
 * Small red badge marking a workshop / organization that has been disabled.
 * Used in the staff list views and detail forms so the state is never ambiguous.
 */
class CBDisabledBadge extends React.Component {
  render() {
    const { t, style } = this.props;

    return (
      <span style={Object.assign({}, styles.badge, style)}>
        {t('statusDisabled')}
      </span>
    );
  }
}

const styles = {
  badge: {
    display: 'inline-block',
    backgroundColor: '#e74c3c',
    color: '#FFFFFF',
    fontFamily: 'TitilliumWeb-SemiBold',
    fontSize: 11,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    borderRadius: 10,
    padding: '2px 8px',
    whiteSpace: 'nowrap',
  },
};

export default translate('SettingsView')(CBDisabledBadge);
